import Immutable from 'immutable';
import EventsConstants from '../../constants/EventsConstants';

const initialState = Immutable.fromJS({
  results: [],
  featuredEvent: {},
  pagination: {},
  facetFields: {},
  query: {},
  isFetching: false,
  eventsRSSLink: '',
  interestedEvents: []
});

export default function eventsSearch(state = initialState, action) {
  switch (action.type) {
    case EventsConstants.SEARCH_EVENTS_REQUEST: {
      return state.merge({
        isFetching: true
      });
    }

    case EventsConstants.SEARCH_EVENTS_SUCCESS: {
      return state.merge(Immutable.fromJS(action.payload.events), {
        query: Immutable.fromJS(action.query),
        isFetching: false,
        eventsRSSLink: action.payload.eventsRSSLink
      });
    }

    case EventsConstants.SEARCH_EVENTS_FAILURE: {
      return initialState;
    }

    case EventsConstants.FETCH_CALLOUT_FEATURED_EVENT_SUCCESS: {
      return state.merge({
        featuredEvent: Immutable.fromJS(action.payload.events.items[0])
      });
    }

    case EventsConstants.FETCH_INTERESTED_EVENTS_SUCCESS: {
      return state.merge({
        interestedEvents: Immutable.fromJS(action.payload.results)
      });
    }

    case EventsConstants.ADD_INTERESTED_EVENTS_SUCCESS: {
      const interested = state
        ?.get('interestedEvents')
        .toJS()
        .slice();
      interested.splice(interested.length, 0, action.payload);
      return state.merge({
        interestedEvents: Immutable.fromJS(interested)
      });
    }

    case EventsConstants.REMOVE_INTERESTED_EVENTS_SUCCESS: {
      const interested = state
        .get('interestedEvents')
        .filter(item => item?.get('registration') !== action.payload.registration);
      return state.merge({
        interestedEvents: interested
      });
    }

    default:
      return state;
  }
}
